


























































































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Detail from "./discoverydetail.vue";

@Component({
  components: {
    Detail
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "stadium/discovery";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "上报人", scopedSlots: { customRender: "username" } },

    { title: "场馆名称", dataIndex: "stadium_name" },
    { title: "省份", dataIndex: "province_name" },
    { title: "城市", dataIndex: "city_name" },
    { title: "场馆地址", scopedSlots: { customRender: "stadium_addr" } },
    { title: "场馆电话", dataIndex: "stadium_phone" },
    { title: "馆长电话", dataIndex: "stadium_manager_mobile" },
    { title: "片场数", dataIndex: "grounds" },
    { title: "价格", dataIndex: "price" },
    { title: "上报时间", dataIndex: "created_time" },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  // 操作搜索栏的展开和折叠
  isFlag = false;

  mounted() {
    this.loadData();
  }
}
